export interface EnvironmentConfig {
    readonly g2SearchBaseUrl: string;
}

export const envConfig: EnvironmentConfig = {
    get g2SearchBaseUrl() { return window.env.g2SearchBaseUrl },
};
